import React from "react";
import PropTypes from "prop-types";
import { Typography, Box } from "@mui/material";
import { LocationOnOutlined as LocationIcon } from "@mui/icons-material";
import { courseTypes } from "../../constants";
import { useTranslation } from "react-i18next";

const getLocation = (location, courseType) => {
  const { t } = useTranslation();
  const type = courseType ? courseType.toLowerCase() : null;
  if (
    type === courseTypes.webinar.toLowerCase() ||
    type === courseTypes.virtual.toLowerCase() ||
    type === courseTypes.online.toLowerCase()
  ) {
    return t("courseCard.courseType.virtual");
  } else if (location && type === courseTypes.ilt.toLowerCase()) {
    return `${location.city}, ${location.state}`;
  } else {
    return null;
  }
};

const IltClassLocation = ({ location, courseType }) => {
  const iltLocation = getLocation(location, courseType);
  return iltLocation ? (
    <Box display="flex" alignItems="center">
      <Box mr={1} display="flex" alignItems="center">
        <LocationIcon fontSize="small" />
      </Box>
      <Typography variant="caption" color="textSecondary">
        {iltLocation}
      </Typography>
    </Box>
  ) : null;
};

export default IltClassLocation;

IltClassLocation.propTypes = {
  location: PropTypes.object,
  courseType: PropTypes.string
};
